import { AxiosResponse } from "axios";
import { BaseSchool } from "./bases/base.service";
import { SUBDOMAIN } from "@/constants/portal.constant";

export default class SchoolService {
  public login(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("auth/login", params);
  }
  public request(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("auth/request", params);
  }
  public reset(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("auth/reset", params);
  }
  public getSchoolProfile(): Promise<AxiosResponse<any>> {
    return BaseSchool().get("landing/get/profile", {
      params: {
        subdomain: SUBDOMAIN,
      },
    });
  }
  public getSchoolJobs(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get("landing/get/jobs", {
      params: {
        subdomain: SUBDOMAIN,
        ...params,
      },
    });
  }
  public getSchoolNews(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get("landing/get/news", {
      params: {
        subdomain: SUBDOMAIN,
        ...params,
      },
    });
  }
  public getSchoolNewsDetail(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`landing/get/news/detail/${params.id}`, {
      params: {
        subdomain: SUBDOMAIN,
        ...params,
      },
    });
  }
  public getSchoolEvents(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get("landing/get/events", {
      params: {
        subdomain: SUBDOMAIN,
        ...params,
      },
    });
  }
  public getSchoolEventDetail(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`landing/get/event/detail/${params.id}`, {
      params: {
        subdomain: SUBDOMAIN,
        ...params,
      },
    });
  }
  public getCandidateDetail(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`landing/get/candidate/detail/${params.id}`, {
      params: {
        subdomain: SUBDOMAIN,
        ...params,
      },
    });
  }
  public candidateRegisterSendOtp(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseSchool().post("candidate/send/otp", params);
  }
  public candidateRegisterValidateOtp(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseSchool().post("candidate/validate/otp", params);
  }
  public candidateRegisterRegister(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseSchool().post("candidate/register", params);
  }
  public partnershipFind(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`partnership/${SUBDOMAIN}/find`, { params });
  }
  public partnershipLatestAgreement(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`partnership/${SUBDOMAIN}/latest-agreement`, {
      params,
    });
  }
  public partnershipCheckLatestAgreement(
    params: any = {}
  ): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`partnership/${SUBDOMAIN}/check-latest-agreement`, {
      params,
    });
  }
  public partnershipSendOtp(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post(`partnership/${SUBDOMAIN}/send-otp`, params);
  }
  public partnershipValidate(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post(`partnership/${SUBDOMAIN}/validate`, params);
  }
  public partnershipRegister(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post(`partnership/${SUBDOMAIN}/register`, params);
  }
  public requestSetCredential(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("request/set-credential", params);
  }
  public requestSetCredentialFree(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("request/set-credential-free", params);
  }
  public requestTakeover(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("request/takeover", params);
  }
  public getTemplate(): Promise<AxiosResponse<any>> {
    return BaseSchool().get("landing/template/get", {
      params: {
        subdomain: SUBDOMAIN,
      },
    });
  }
  public getPageDefault(): Promise<AxiosResponse<any>> {
    return BaseSchool().get("landing/template/page/get/default", {
      params: {
        subdomain: SUBDOMAIN,
      },
    });
  }
  public getPageDetail(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`landing/template/page/detail/${params.slug}`, {
      params: {
        subdomain: SUBDOMAIN,
        ...params,
      },
    });
  }
  public tracerStudyLogin(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("tracer-study/login", params);
  }
  public getTracerDetail(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().get(`tracer-study/landing-detail/${params.id}`, {
      params: {
        subdomain: SUBDOMAIN,
        ...params,
      },
    });
  }
  public validateCandidateCode(params: any = {}): Promise<AxiosResponse<any>> {
    return BaseSchool().post("candidate/validate/code", params);
  }
}
